import { AxiosInstance } from 'axios';
import {
  MarketResponse,
  MarketsResponse,
} from 'data/terra/api/terra/response/MarketResponse';
import { MarketDescription } from 'data/terra/Market';
import { result, Result } from 'util/result';
import Terra from '../Terra';

class MarketEndpoint {
  getMarketsUrl = () =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/markets`;
  getMarketDetailUrl = (marketId: string) =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/markets/${marketId}`;
}


export class MarketApi {
  terraClient: AxiosInstance;
  endpoint = new MarketEndpoint();

  constructor(client: AxiosInstance) {
    this.terraClient = client;
  }

  fetchMarkets(): Promise<Result<MarketsResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.get<MarketsResponse>(
            this.endpoint.getMarketsUrl()
          )
        ).data
    );
  }

  addMarket(data: MarketDescription): Promise<Result<MarketResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.post<MarketResponse>(
            this.endpoint.getMarketsUrl(),
            data
          )
        ).data
    );
  }
}